import { render, staticRenderFns } from "./organizationForm.vue?vue&type=template&id=585be2a1&"
import script from "./organizationForm.vue?vue&type=script&lang=js&"
export * from "./organizationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports